import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { desabilitarAcoes, modoSelecaoSimcard } from '../redux/actions/index'
import { useGlobal } from '../stores/useGlobal.js'

export function ResetOnRouteChange() {
  const location = useLocation()
  const dispatch = useDispatch()
  const setSelecionarParqueInteiro = useGlobal(
    (s) => s.setSelecionarParqueInteiro
  )
  const setTemItensTabelaSelecionados = useGlobal(
    (s) => s.setTemItensTabelaSelecionados
  )

  useEffect(() => {
    setSelecionarParqueInteiro(false)
    dispatch(modoSelecaoSimcard(false))
    dispatch(desabilitarAcoes(true))
    setTemItensTabelaSelecionados(false)
  }, [
    location.pathname,
    dispatch,
    setSelecionarParqueInteiro,
    setTemItensTabelaSelecionados
  ])

  return null
}
